import { gql } from "@apollo/client";

export const GET_ONLINE_PHARMACY_CONFIG = gql`
  query getOnlinePharmacyConfig {
    onlinePharmacyConfig {
      isServiceEnabled
      shopUrl
      comingSoon {
        title
        message
        imageUrlWeb
        learnMoreUrl
      }
      banner {
        title
        description
        buttonText
        imageUrlWeb
        actionUrl
      }
    }
  }
`;
